import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from 'vue'
import RankingChart from '@/views/dashboard/_components/ranking-chart/ranking-chart.vue'
import { bytesToSize } from '@/utils/tool'

interface RankingItem {
  name: string
  department: string
  count: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'traffic-ranking-chart',
  props: {
    data: { default: () => [] },
    timeRange: { default: '30d' }
  },
  emits: ["update:timeRange", "itemClick"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const loading = ref(false)

const timeRange = computed({
  get: () => props.timeRange,
  set: (val) => emit('update:timeRange', val)
})

__expose({
  loading
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(RankingChart, {
    title: _ctx.$t('terminalTrafficStateList.trafficTotalTop5'),
    data: _ctx.data,
    "time-range": timeRange.value,
    "onUpdate:timeRange": [
      _cache[0] || (_cache[0] = ($event: any) => ((timeRange).value = $event)),
      _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:timeRange', $event)))
    ],
    loading: loading.value,
    "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((loading).value = $event)),
    "name-key": "name",
    "row-clickable": "",
    onItemClick: _cache[3] || (_cache[3] = (item) => _ctx.$emit('itemClick', item))
  }, {
    titleAfter: _withCtx(() => [
      _createVNode(_component_el_tag, {
        size: "small",
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.rankTagTop5')), 1)
        ]),
        _: 1
      })
    ]),
    "item-name": _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(item.name) + " (" + _toDisplayString(item.department) + ") ", 1)
    ]),
    "count-text": _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(_unref(bytesToSize)(item.count ?? 0)), 1)
    ]),
    _: 1
  }, 8, ["title", "data", "time-range", "loading"]))
}
}

})